import './Main.css'

import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { WizardData } from './Model'
import { goToAddFailurePage, StartAddFailurePage } from '@/pages/communal/machine/failures/add/Main'
import { Machine } from '@/services/model/machine'
import { MachineName } from '@/components/machine'
import { useNavigate } from 'react-router-dom'
import { MachineFailureCategory } from '@/services/repository/machines'

export interface SimpleUserGroup {
  id: string
  name: string
}

export const Step2 = ({ machine }: {
  machine: Machine
}) => {
  const { services, session, translates } = useAppContext()
  const navigate = useNavigate()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <div>
    <h3>{translates.for('machine.checklist.wizard.step2.title')}</h3>
    <p className='desc'>
      {translates.for('machine.checklist.wizard.step2.description')}
    </p>

    <div className='btns'>
      <a className='btn btn-next main-btn' onClick={nextStep}>
        {translates.for('machine.checklist.wizard.step2.approve')}
      </a>
      <a className='btn btn-fail main-red-btn' onClick={() => {
        goToAddFailurePage({
          navigate,
          machineId: machine.id
        }, {
          category: MachineFailureCategory.Other
        })
      }}>
        {translates.for('machine.checklist.wizard.step2.fail')}
      </a>
    </div>

  </div>
}
